<template>
    <div class="header">
      <div class="logo">
        <a href="https://www.pkulaw.com/" target="_blank"><img src="https://www.pkulaw.com/content/images/logo.jpg" alt="北大法宝"></a>
      </div>
      <div class="nav">
        <template v-for="item in heaData">
          <template v-if="item.child">
            <el-popover trigger="hover" v-if="item.child">
              <div class="popBox">
                <p v-for="obj in item.child" @click="handleLink(item,obj)">{{obj.name}}</p>
              </div>
              <span class="li" slot="reference" @click="handleTo(item)">{{item.name}}</span>
            </el-popover>
          </template>  
          <template v-else-if="item.poptip">
            <el-popover v-model="visible[item.name]" trigger="hover">
              <div class="popW">
                <el-row :gutter="40">
                  <el-col v-for="obj in item.poptip" :span="obj.span">
                    <template v-if="obj.table">
                      <template v-if="obj.table.type=='col'">
                        <div class="h">{{obj.title}}</div>
                        <el-row :gutter="20">
                          <el-col v-for="list in obj.list" :span="24/obj.table.num">
                            <div v-for="li in list">{{li.name}}</div>
                          </el-col>
                        </el-row>
                      </template>  
                      <template v-if="obj.table.type=='row'">
                        <template v-for="list in obj.list">
                          <div class="h">{{list.title}}</div>
                          <div v-for="li in list.list">{{li.name}}</div>
                          <div style="height: 30px"></div>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <div class="h">{{obj.title}}</div>
                      <div v-for="li in obj.list">{{li.name}}</div>
                    </template>
                  </el-col>
                </el-row>
              </div> 
              <span class="li" slot="reference" @click="toPage(item.id,item.name,item.name)">{{item.name}}</span>
            </el-popover>
          </template>  
          <template v-else-if="item.block">
            <el-popover v-model="visible[item.name]" trigger="hover">
               <div class="blockW">
                <div class="menu">
                  <div v-for="(obj,index) in item.block" class="li" :class="{'active':(index==num)}" @mouseover="num=index">
                    <el-row>
                      <el-col :span="20">
                        <div @click='toPage(obj.id,obj.name,item.name)'>{{obj.name}}</div>
                      </el-col>
                      <el-col :span="4" v-if="num==index"><i class="el-icon-arrow-right icon"></i></el-col>
                    </el-row>
                  </div>
                </div>
                <div class="box">
                  <el-row :gutter="40">
                    <el-col v-for="obj in item.block[num].poptip" :span="obj.span">
                      <template v-if="obj.table">
                        <template v-if="obj.table.type=='col'">
                          <div class="h" @click='toPage(obj.id,obj.title,item.name)'>{{obj.title}}</div>
                          <el-row :gutter="20">
                            <el-col v-for="list in obj.list" :span="24/obj.table.num">
                              <template v-for="li in list">
                                <div class="active" v-if="li.h">{{li.h}}</div>
                                <div v-else>{{li.name}}</div>
                              </template>
                            </el-col>
                          </el-row>
                        </template>  
                        <template v-if="obj.table.type=='row'">
                          <template v-for="list in obj.list">
                            <div class="h" @click='toPage(list.id,list.title,item.name)'>{{list.title}}</div>
                            <template v-for="li in list.list">
                              <div class="active" v-if="li.h">{{li.h}}</div>
                              <div v-else>{{li.name}}</div>
                            </template>
                            <div style="height: 30px"></div>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <div class="h" @click='toPage(obj.id,obj.title,item.name)'>{{obj.title}}</div>
                        <template v-for="li in obj.list">
                          <div class="active" v-if="li.h">{{li.h}}</div>
                          <div v-else>{{li.name}}</div>
                        </template>
                      </template>
                    </el-col>
                  </el-row>
                </div>
              </div> 
              <span class="li" slot="reference" @click="toPage(item.id,item.name,item.name)">{{item.name}}</span>
            </el-popover>
          </template>  
          <template v-else>
            <span class="li" @click="handleTo(item)">{{item.name}}</span>
          </template>
        </template>  
      </div>
      <div class="qrcode">
        <a class="btn-linkto" href="https://www.pkulaw.com/" target="_blank">法宝主页</a>
        <el-popover trigger="hover">
          <div class="code">
            <img src="/data/image/xcxcode.png">
            <p>法宝小程序</p>
            <p>400-810-8266</p>
            <p>info@chinalawinfo.com</p>
          </div>
          <img src="/data/image/icon/icon_qr.png?1" slot="reference">
        </el-popover>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'Header',
    data() {
      return {
        heaData: window.heaData,
        num: 0,
        visible: {
          '内容产品': false,
          '法律科技': false,
          '解决方案': false
        }
      }
    },
    methods: {
      handleTo(obj){
        if (this.$route.name == obj.id) {
          this.$emit('returnRouterIndex')
        }
        this.$router.push({name: obj.id})
      },
      handleLink(data,obj){
        if (this.$route.name == data.id) {
          this.$emit('returnRouterIndex', obj.name)
        }
         this.$router.push({
            name:  data.id,
            query: {
              name: obj.name
            }
          })
      },
      toPage(id,name,key){
        if(id){
          if(this.$route.query.name==name){
            return
          }
          this.visible[key] = false
          this.$router.push({
            name:  id,
            query: {
              name: name
            }
          })
        }
      }
    }
  }
</script>
<style scoped>
  .header {
    position: fixed;
    width: 100%;
    max-width: 1920px;
    top: 0;
    height: 60px;
    background: #fff;
    color: #301333;
    z-index: 9;
    box-shadow: 0 1px 12px rgba(117,140,173,.16);
  }
  .logo {
    margin: 13px 20px 0;
    float: left;
  }
  .nav{
    margin: 10px 20px;
    line-height: 40px;
    font-size: 14px;
  }
  .nav .li{
    cursor: pointer;
    margin: 0 22px;
  }
  .nav .li:hover{
    color: #1867dd;
  }
  .popBox{
    text-align: center;
  }
  .popBox p{
    line-height: 42px;
    cursor: pointer;
  }
  .popBox p:hover{
    background: #f1f1f1;
    color: #1867dd;
  }
  .blockW,.popW{
    overflow-y: auto;
    overflow-x: hidden;
    line-height: 32px;
    color: #2f2e3f;
  }
  .popW{
    padding: 10px 30px 30px;
    width: calc(100vw - 112px);
    max-height: calc(100vh - 160px);
    max-width: 1808px;
  }
  .popW .h,.blockW .h{
    cursor: pointer;
    font-weight: bolder;
    border-bottom: 1px solid #e4e7eb;
  }
  .blockW{
    width: calc(100vw - 52px);
    max-height: calc(100vh - 120px);
    max-width: 1868px;
  }
  .blockW::after{
    content: '';
    clear: both;
    display: block;
  }
  .blockW .menu{
    float: left;
    text-align: center;
    width: 260px;
    font-weight: bolder;
    line-height: 42px;
  }
  .blockW .menu .li{
    cursor: pointer;
  }
  .blockW .menu .li .icon{
    color: #1867dd;
  }
  .blockW .menu .li:hover,.blockW .menu .li.active{
    background: #f1f1f1;
    color: #1867dd;
  }
  .blockW .box{
    margin-left: 260px;
    padding-left: 40px;
    padding-bottom: 50px;
    border-left: 1px solid #e4e7eb;
  }
  .blockW .box .active{
    color: #1867dd;
  }
  .qrcode{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 15px;
  }
  .btn-linkto {
    padding: 5px 12px;
    font-size: 14px;
    color: #fff;
    background-color: #1867DD;
    line-height: 20px;
    margin-right: 20px;
    text-decoration: none;
  }
  .code{
    text-align: center;
  }
  .code img{
    width: 126px;
  }
</style>